import AdvisorCard from "@modules/advisory-team/components/AdvisorCard";
import AdvisorTeamLocked from "@modules/advisory-team/components/AdvisorTeamLocked";
import { useHousehold, useHouseholdAdvisors } from "@common/queries";
import { withPageAuthRequired } from "@common/middleware";
import { Typography } from "@earned/core";
import LoadingIndicator from "@common/components/LoadingIndicator";
import { sortAdvisorsByRoleAndTitle } from "@common/utils";

const AdvisorsPage = () => {
  const { data: household } = useHousehold();
  const { data: advisors, isLoading: isAdvisorsLoading } =
    useHouseholdAdvisors();

  const visibleAdvisors = advisors?.filter(
    (advisor) => !advisor.isHiddenFromClientPortal
  );

  if (!household) return null;
  if (isAdvisorsLoading) {
    return <LoadingIndicator isVisible />;
  }

  return (
    <div className="flex flex-1 flex-col font-medium">
      <div className="flex flex-1 flex-col overflow-y-auto">
        <div className="flex flex-col px-10 pb-10">
          <div className="py-6">
            <Typography variant="body" weight="medium" color="primary">
              Current Team
            </Typography>
          </div>
          <div className="grid grid-cols-1 content-center gap-7 sm:grid-cols-[repeat(auto-fill,_minmax(480px,480px))]">
            {!!visibleAdvisors && visibleAdvisors?.length > 0 ? (
              <>
                {sortAdvisorsByRoleAndTitle(visibleAdvisors).map((advisor) => (
                  <AdvisorCard
                    key={advisor.id}
                    advisor={advisor}
                    isLockedAdvisoryTeam={!household.primaryWealthAdvisorId}
                    advisorName={advisor.firstName + " " + advisor.lastName}
                  />
                ))}
                <AdvisorCard
                  isLockedAdvisoryTeam={!household.primaryWealthAdvisorId}
                  advisorName="Client Service & Operations"
                />
              </>
            ) : (
              <>
                <AdvisorCard
                  isLockedAdvisoryTeam={!household.primaryWealthAdvisorId}
                  advisorName="Client Service & Operations"
                />
              </>
            )}
          </div>
        </div>
        {(!visibleAdvisors || visibleAdvisors.length === 0) && (
          <div className="flex flex-1 bg-offwhite">
            <AdvisorTeamLocked />
          </div>
        )}
      </div>
    </div>
  );
};

export default withPageAuthRequired(AdvisorsPage);
